export default __webpack_public_path__ + "static/media/norwaygo-screenshot-02.eb71bbc5.png";